import type { ServiceIntervalConfig, WearStatus } from '../../types';

const PERCENT_MULTIPLIER = 100;

export const getWearPercent = ({
    interval,
    usage
}: {
    interval?: ServiceIntervalConfig;
    usage: number;
}): WearStatus => {
    if (!interval || interval.value <= 0) {
        return { configured: false };
    }

    return { configured: true, percentage: (usage / interval.value) * PERCENT_MULTIPLIER };
};
